import { render, staticRenderFns } from "./BusinessPendingList.vue?vue&type=template&id=3fe9f86b&"
import script from "./BusinessPendingList.vue?vue&type=script&lang=js&"
export * from "./BusinessPendingList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPendingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports